// removed by extract-text-webpack-plugin
module.exports = {"student-table":"student-table","student-info":"student-info","student-info-container":"student-info-container","portrait":"portrait","hasPhoto":"hasPhoto","text-container":"text-container","name":"name","class-info":"class-info","class-info-container":"class-info-container","class-info-name":"class-info-name","exit-class":"exit-class","alert-text":"alert-text","expand-folded-classes-button":"expand-folded-classes-button","button-text":"button-text"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/pages/Student/StudentTable/student-table.scss
// module id = A9k/
// module chunks = 0